import { PaymentOriginEnum } from '@frontend/api-invoices';
import { JustifiPaymentPortal, StripePaymentPortal } from '../portals';
import { FailureHandler, PortalDataType, SuccessHandler } from '../types';
import { VariantSwitch } from './variant-switch';

export interface ProcessorSwitchProps {
  portalData?: PortalDataType;
  origin: PaymentOriginEnum;
  amount?: number;
  amountEditable?: boolean;
  captchaToken?: string | null;
  onSuccess?: SuccessHandler;
  onFailure?: FailureHandler;
  paymentConfig?: string;
  refetchPortalData?: () => void;
  showLocationInfo?: boolean;
}

export const ProcessorSwitch = (props: ProcessorSwitchProps) => {
  const { portalData } = props;

  return (
    <VariantSwitch
      primaryVariantEnabled={portalData?.locationData?.processor === 'stripe'}
      primaryVariant={StripePaymentPortal}
      secondaryVariant={JustifiPaymentPortal}
      primaryProps={props}
      secondaryProps={props}
    />
  );
};
